import type { GetSigninResponse } from './types';

import { getGenericEndpoint } from './get.api';

type ProvideType = 'email' | 'mobile';

export const getProvide = async (type: ProvideType, lang?: string) => {
    return await getGenericEndpoint<GetSigninResponse>(`signin/provide-${type}`, lang);
};
